(function () {
  function setupRoot(root) {
    if (!root) return;

    var rafToken = 0;

    function equalize() {
      var headings = root.querySelectorAll('.card__heading');
      if (!headings.length) return;

      for (var i = 0; i < headings.length; i++) {
        headings[i].style.minHeight = '';
      }

      var rows = new Map();
      for (var j = 0; j < headings.length; j++) {
        var h = headings[j];
        if (h.offsetParent === null) continue;
        var top = Math.round(h.getBoundingClientRect().top);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(h);
      }

      rows.forEach(function (group) {
        if (group.length < 2) return;
        var maxH = 0;
        for (var k = 0; k < group.length; k++) {
          if (group[k].offsetHeight > maxH) maxH = group[k].offsetHeight;
        }
        for (var m = 0; m < group.length; m++) {
          group[m].style.minHeight = maxH + 'px';
        }
      });
    }

    function schedule() {
      if (rafToken) cancelAnimationFrame(rafToken);
      rafToken = requestAnimationFrame(equalize);
    }

    equalize();

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(equalize);
    }

    window.addEventListener('resize', schedule, { passive: true });

    new MutationObserver(schedule).observe(root, { childList: true, subtree: false });

    new MutationObserver(schedule).observe(root, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  function setup() {
    var selectors = ['.collection .product-grid', '.DT_listcols__strip'];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(setupRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
